import React from "react";
import { Text, makeStyles, tokens } from "@fluentui/react-components";
import { useFormContext } from "react-hook-form";
import { OrderFormData } from "../../../interfaces/OrderFormData";
import { Grid } from "../../common/grid/Grid";
import { GridItem } from "../../common/grid/GridItem";
import { ControlledPhoneInput } from "../../inputs/ControlledPhoneInput";
import { ControlledTextInput } from "../../inputs/ControlledTextInput";
import { t } from "../../../i18n/i18n";

const useStyles = makeStyles({
  sectionHeader: {
    display: "flex",
    flexDirection: "column",
    rowGap: tokens.spacingVerticalXS,
  },
});

export const OrderConfirm = () => {
  const classes = useStyles();

  const {
    control,
  } = useFormContext<OrderFormData>();

  return (
    <>
      <Grid>
        <GridItem size="12/12">
          <div className={classes.sectionHeader}>
            <Text size={600} weight="bold">
              {t("ContactInformation")}
            </Text>
            <Text size={300}>{t("FillInYourContactDetails")}</Text>
          </div>
        </GridItem>

        <GridItem size="6/12">
          <ControlledTextInput
            required
            control={control}
            type="text"
            name={"contactDetails.firstName"}
            label={t("FirstName")}
            placeholder={t("FirstNamePlaceholder")}
          />
        </GridItem>
        <GridItem size="6/12">
          <ControlledTextInput
            required
            control={control}
            type="text"
            name={"contactDetails.lastName"}
            label={t("LastName")}
            placeholder={t("LastNamePlaceholder")}
          />
        </GridItem>

        <GridItem size="6/12">
          <ControlledPhoneInput
            required
            control={control}
            name={"contactDetails.contactPhoneNumber"}
            label={t("PhoneNumber")}
            placeholder={t("PhoneNumberPlaceholder")}
          />
        </GridItem>
        <GridItem size="6/12">
          <ControlledTextInput
            required
            control={control}
            type="email"
            name={"contactDetails.contactEmail"}
            label={t("Email")}
            placeholder={t("EmailPlaceholder")}
          />
        </GridItem>

        <GridItem size="12/12">
          <ControlledTextInput
            multiline
            control={control}
            type="text"
            name={"contactDetails.otherInformation"}
            label={t("OtherInformation")}
          />
        </GridItem>
      </Grid>
    </>
  );
};
